'use client'

import { CourseCard, CourseCardLink } from '~/components/course-card'
import { Headline } from '~/components/headline'
import { Skeleton } from '~/components/ui/skeleton'
import { useSession } from '~/lib/auth.client'
import QUESTIONS_DATA from '../_static/questions.json' with { type: 'json' }

export default function Page() {
  const { data: session, isPending } = useSession()

  return (
    <div className={`
      mx-auto my-4 w-full max-w-[calc(100%-2rem)] space-y-6 rounded-2xl bg-gradient-to-br from-muted to-muted/50 px-10
      py-10 shadow-sm
    `}
    >
      <div className="space-y-3 border-b border-border/40 pb-6">
        <Headline>Шпаргалки Вадима</Headline>
        <p className="text-base leading-relaxed text-muted-foreground">
          Обширная коллекция вопросов для подготовки к собеседованиям по различным направлениям.
          Структурированная база знаний с теоретическими вопросами и практическими задачами.
        </p>
      </div>

      <div className="grid grid-cols-1 items-start gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
        {QUESTIONS_DATA.map((course) => {
          if (isPending) {
            return <Skeleton className="h-24 w-full" key={course.pageId} />
          }

          if (session) {
            return (
              <CourseCardLink
                description={course.description}
                href={`/plus/questions/${course.pageId}`}
                key={course.pageId}
                title={course.title}
              />
            )
          }

          return <CourseCard key={course.pageId} {...course} />
        })}
      </div>
    </div>
  )
}
